(() => {
  const PACK_SIZE = 4;

  const formatPackLabel = (node, packCount) => {
    const template =
      packCount === 1 ? node.dataset.packLabelSingularTemplate : node.dataset.packLabelPluralTemplate;

    if (template) return template.replace('[count]', String(packCount));
    return packCount === 1 ? `${packCount} pack` : `${packCount} packs`;
  };

  const updatePackQuantityLabel = (input) => {
    if (!input?.matches('.cart-item .quantity__input')) return;

    const cartItem = input.closest('.cart-item');
    if (!cartItem) return;

    const quantity = Number.parseInt(input.value, 10);
    if (Number.isNaN(quantity)) return;

    const packCount = Math.round(quantity / PACK_SIZE);
    const quantityNodes = cartItem.querySelectorAll('[data-pack-quantity]');

    quantityNodes.forEach((node) => {
      const label = node.querySelector('.cart-pack-quantity__label');
      if (!label) return;

      node.dataset.packQuantity = String(packCount);
      label.textContent = formatPackLabel(node, packCount);
    });
  };

  const updatePackQuantityLabels = (root = document) => {
    root.querySelectorAll('.cart-item .quantity__input').forEach(updatePackQuantityLabel);
  };

  document.addEventListener('DOMContentLoaded', () => {
    updatePackQuantityLabels();
  });

  document.addEventListener('change', (event) => {
    updatePackQuantityLabel(event.target);
  });

  document.addEventListener('shopify:section:load', (event) => {
    updatePackQuantityLabels(event.target);
  });

  window.updatePackQuantityLabel = updatePackQuantityLabel;
})();
